import { Divider } from 'antd'
import WizrFlexLayout from '../WizrFlexLayout'
import WizrText from '../WizrText'
import WizrButton from '../WizrButton'
import CloseIcon from '../../assets/icons/Close'
import WizrTag from '../WizrTags'
import WizrAvatar from '../WizrAvatar'
import WizrFlexSpacing from '../WizrFlexSpacing'
import styled from 'styled-components'

interface ITicketDetailsModal {
  rowDetails?: any
  onCancel?: () => void
}

const StyledWizrTag = styled(WizrTag)`
  height: 42px;
  padding: 8px 11px;
  justify-content: space-between;
`

const StyledFlexSpacing = styled(WizrFlexSpacing)`
  .ant-space-item {
    display: flex !important;
    width: 100% !important;
    flex-wrap: wrap;
  }
`

const TicketDetailsModal = ({ rowDetails, onCancel }: ITicketDetailsModal): JSX.Element => {
  const conversations = rowDetails?.conversation;

  let extractedConversations = [];
  try {
    const jsonWithSingleBackslash = conversations?.replace(/\\/g, '"');
    const data = JSON.parse(jsonWithSingleBackslash);
    const array = data[0];
    extractedConversations = array.map((item: any) => ({
      question: item.comment_text,
      user: item.comment_username,
    }));
  } catch (error) {
    console.error("Error parsing JSON:", error);
  }

  return (
    <WizrFlexLayout background='white'>
      <WizrFlexLayout
        flexDirection='row'
        alignItems='center'
        background='white'
        justifyContent='space-between'
        style={{ marginBottom: '16px' }}
      >
        <WizrText type='sub1'>Ticket Details</WizrText>
        <WizrButton
          type='link'
          icon={<CloseIcon />}
          onClick={onCancel}
          style={{ padding: '0px', display: 'flex', alignItems: 'center' }}
        ></WizrButton>
      </WizrFlexLayout>
      <WizrFlexLayout background='white'>
        <WizrFlexLayout
          alignItems='space-between'
          background='white'
          justifyContent='flex-start'
        >
          <WizrText type='body2' style={{ textAlign: 'left' }}>{rowDetails?.organization_name}</WizrText>

          <WizrFlexLayout
            alignItems='space-between'
            background='white'
            justifyContent='space-between'
            flexDirection='row'
          >
            <WizrText type='body2'>Ticket ID :{rowDetails?.ticket_id}</WizrText>
            <WizrText type='body2'>Task</WizrText>
          </WizrFlexLayout>
        </WizrFlexLayout>

        <WizrFlexLayout
          flexDirection='row'
          alignItems='space-between'
          background='white'
          justifyContent='space-between'
        >
          <WizrTag background='white' data={['DISABLED']} borderradius='4px' />
        </WizrFlexLayout>
        <WizrAvatar background='transparent' name={rowDetails?.raised_by}></WizrAvatar>
        <WizrFlexLayout flexDirection='row' justifyContent='flex-start' background='white'>
          <WizrTag background='#EF4444' data={[rowDetails?.priority]} borderradius='4px' />
          <WizrTag background='#22C55E' data={[rowDetails?.sentiment]} borderradius='4px' />
        </WizrFlexLayout>
        <WizrFlexLayout
          flexDirection='row'
          alignItems='space-between'
          background='white'
          justifyContent='space-between'
          style={{ marginTop: '5px' }}
        >
          <WizrText type='caption'>Created On</WizrText>
          <WizrText type='caption'>Closed On</WizrText>
        </WizrFlexLayout>
        <WizrFlexLayout
          flexDirection='row'
          alignItems='space-between'
          background='white'
          justifyContent='space-between'
        >
          <WizrText type='body2'>{rowDetails?.ticket_created_on}</WizrText>
          <WizrText type='body2'>{rowDetails?.ticket_closed_on}</WizrText>
        </WizrFlexLayout>
        <Divider style={{ margin: '10px 0px' }} />
        <WizrFlexLayout
          flexDirection='column'
          alignItems='flex-start'
          background='white'
          textAlign='left'
        >
          <WizrText type='body2'>{rowDetails?.subject}</WizrText>
          <WizrText type='caption'>
            {rowDetails?.description}
          </WizrText>

          <StyledFlexSpacing
            justifyContent='space-between'
            flexDirection='column'
            alignItems='center'
            size={20}
            background='white'
          >
            <StyledWizrTag
              background='grey'
              data={rowDetails?.tags?.split(',')}
            />
          </StyledFlexSpacing>
        </WizrFlexLayout>
        {extractedConversations?.map((item: any) => [
          <Divider key={`divider-${item.user}-${item.question.substring(0, 10)}`} style={{ margin: '10px 0px' }} />,
          <WizrFlexLayout key={`layout-${item.user}-${item.question.substring(0, 10)}`} flexDirection='column' alignItems='flex-start' background='white'>
            <WizrText type='body2'>{item?.user}</WizrText>
            <WizrFlexLayout flexDirection='row' justifyContent='flex-start' style={{ marginTop: '5px' }}>
              <WizrFlexLayout style={{ maxWidth: '100%' }} background='white' textAlign='left'>
                <WizrText type='caption'>{item?.question}</WizrText>
              </WizrFlexLayout>
            </WizrFlexLayout>
          </WizrFlexLayout>
        ])}
      </WizrFlexLayout>
    </WizrFlexLayout>
  )
}

export default TicketDetailsModal

